import Vue from 'vue'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/style.css'
import router from './router'
import App from './components/App'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueCookies from 'vue-cookies'
import VueLazyload from "vue-lazyload";
import 'swiper/dist/css/swiper.css'
import'../theme/index.css'
import locale from 'element-ui/lib/locale/lang/en';

Vue.use(VueAwesomeSwiper)
Vue.use(VueCookies)
Vue.use(ElementUI,{locale});
Vue.use(VueLazyload)




Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}


import 'vant/lib/index.css';


new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js